import { inject, Injectable } from '@angular/core';
import { PaymentSummaryDataDto, PaymentSummaryParamsDto } from '@data/data/models/payment-summary.dto';
import { PaymentRepository } from '@data/repositories/payment.repository';
import { UseCase } from '@shared/helper';
import { Observable } from 'rxjs';

@Injectable({
    providedIn:'root'
})

export class PaymentSummaryUsecase implements UseCase<PaymentSummaryParamsDto, PaymentSummaryDataDto> {
    private readonly paymentRepository = inject(PaymentRepository);

    execute(params: PaymentSummaryParamsDto): Observable<PaymentSummaryDataDto> {
        return this.paymentRepository.paymentSummary(params);
    }
}
